/**
 * Everything that leaves the document flow sits on one layer.
 *
 * Nesting is resolved by portal order, never by competing z-indexes. Every
 * overlay in this package portals to the end of `<body>`, so a Select opened
 * inside a Dialog opened inside a Drawer is appended after both and paints on
 * top because it is later in the document, not because someone gave it a bigger
 * number. That is the only ordering rule that survives arbitrary nesting.
 *
 * The moment two overlays carry different z-indexes, the deeper one can lose to
 * the shallower one and the fix becomes a bigger number, then a bigger one
 * again. One constant means that conversation cannot start.
 *
 * `isolate` is deliberately absent: a stacking context here would trap a child
 * popup inside its parent, which is the bug this is preventing.
 */
export const OVERLAY_LAYER = 'z-50'

/**
 * The layer belongs on the Positioner, not on the Popup.
 *
 * Base UI leaves its Popup `position: static` and positions the wrapper around
 * it, and `z-index` does nothing on a static element. A layer set on the Popup
 * therefore silently does nothing: the whole subtree stacks at `auto` and loses
 * to any ancestor that has a real one. That is not a hypothesis, it is what a
 * dropdown inside a Drawer did before this comment existed.
 */

/**
 * A portalled surface can land in a host that has switched pointer events off
 * on the body. Radix does that while one of its own modals is open, and
 * re-enables them only on its own subtree, so a popup from this package nested
 * inside a Radix modal is unclickable. Every app migrating onto this package
 * spends time in exactly that mixed state.
 */
export const OVERLAY_SURFACE = 'pointer-events-auto'
